import mergeObj from '../extraUtil/mergeTwoObj';

let chart = {
    "animation": "0",
    "caption":"Bill Amount For Orders By Destination States",
    "captionFontColor":"#bebebe",
    "showLabels": "1",
    "showborder": "1",
    "showcanvasborder": "0",
    "showhovereffect": "1",
    "bordercolor": "#717170",
    "borderthickness": "1",
    "nullEntityAlpha": "0",
    "showlegend":"0",
    "useHoverColor":"1",
    "hoverColor":"#589188",
    "updateAnimDuration":"1",
    "numberPrefix":"$"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    chart = mergeObj(chart, theme);
    let dataSource = {},
        states = [],
        data = [],
        statesObj = {};
    for (let i = 0; i < rawData.length; i++) {
        let state = rawData[i]['destinationState'];
        if (!states.includes(state)) {
            states.push(state);
        }
    }
    for (let i = 0; i < states.length; i++) {
        statesObj[states[i]] = 0;
    }
    for (let i = 0; i < rawData.length; i++) {
        let state = rawData[i]['destinationState'];
        rawData[i]['billAmount'] && (statesObj[state] +=  parseFloat(rawData[i]['billAmount']));
    }
    for (let index = 0; index < states.length; index++) {
        let dataObj = {
            "id": states[index],
            "value": statesObj[states[index]].toFixed(2)
        }
        data.push(dataObj);
    }
    dataSource = {
        chart: chart,
        data: data,
        colorrange: {
            "gradient": "0",
            "color": [
                {
                    "minvalue": "0",
                    "maxvalue": "100",
                    "code": "#64A38C",
                    "alpha":"10"
                },
                {
                    "minvalue": "101",
                    "maxvalue": "1000",
                    "code": "#64A38C",
                    "alpha":"30"
                },
                {
                    "minvalue": "1001",
                    "maxvalue": "5000",
                    "code": "#64A38C",
                    "alpha":"60"
                },
                {
                    "minvalue": "5001",
                    "maxvalue": "100000",
                    "code": "#64A38C",
                    "alpha":"100"
                }
            ]
        }
    }
    return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/usaMapSecondGenerator.js